import { render, staticRenderFns } from "./teamSBtable.vue?vue&type=template&id=f610519e&scoped=true"
import script from "./teamSBtable.vue?vue&type=script&lang=js"
export * from "./teamSBtable.vue?vue&type=script&lang=js"
import style0 from "./teamSBtable.vue?vue&type=style&index=0&id=f610519e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f610519e",
  null
  
)

export default component.exports